import APIService from 'services/APIService'
import qs from 'qs'

const api = APIService()

export const getDashboardLayout = (altitude = 'portfolio') => {
  const queryString = qs.stringify({ altitude }, { addQueryPrefix: true })
  return api.get(`/me/dashboard/layout${queryString}`)
}

export const saveDashboardLayout = ({ altitude, layout }) =>
  api.put('/me/dashboard/layout', { altitude, layout })

export const saveOrgDashboardLayout = ({ altitude, layout }) =>
  api.put('/me/dashboard/org-layout', { altitude, layout })

export const resetDashboardLayout = (altitude = 'portfolio') => {
  const queryString = qs.stringify({ altitude }, { addQueryPrefix: true })
  return api.delete(`/me/dashboard/layout${queryString}`)
}
